module.exports = __webpack_public_path__ + "img/11_111.2619feca.png";